// removed by extract-text-webpack-plugin
module.exports = {"subscriptionSuccessBox":"_39pQX36c_9pQ-WY-tkCTbg","subscriptionSuccessBoxInner":"_2Snj2eFcUrndjfRJO0jlwA","button":"_2shuThaxmrySqu4cV9B0ET"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/SubscriptionSuccessBox.scss
// module id = 2919
// module chunks = 0